import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import './journey-edit-holiday.css'
import Select from "react-select";
import { americanDate, formatedDate } from '../../util/date';
import Loading from '../loading/Loading';
import axios from 'axios';
import url from '../../url';
import { store } from 'react-notifications-component';
import ModernAlert from '../alert/ModernAlert';


class JourneyEditHoliday extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            alert: { msg: '', type: '' },
            loading: true,
            holidayName: '',
            dataHolidayEdit: {
                ...this.props.data,
                date: americanDate(this.props.data.date)
            }
        }
    }

    componentDidMount = () => {
        setTimeout(() => {
            this.getTheLohiday()
        }, 500);

    }

    getTheLohiday = () => {
        axios.get(`${url}/v1/telemetria/registrable/HolidayCrudService/${this.props.data._id}/${this.props.token}`)
            .then(d => {
                this.setState({ loading: false, dataHolidayEdit: { ...d.data, date: americanDate(d.data.date)}, holidayName: d.data.scopeStr })
            })
            .catch(e => {
                console.log(e.response)
                var errorMsg = e.response.data.errorMessage
                this.setState({ loading: false })
                this.props._close()
                errorMsg.forEach(d => {
                    if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                    else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
                })
            })
    }

    editHoliday = () => {
        const body = this.state.dataHolidayEdit
        axios.post(`${url}/v1/telemetria/registrable/HolidayCrudService/${this.props.token}`, body)
            .then(d => {
                console.log(d)
                store.addNotification({ ...this.props.bodyNotify, title: `${body.scopeStr} foi alterado!`, type: 'success', message: `${body.description} - ${formatedDate(body.date)}` });
                this.props._close()
                this.props._callBack()
            }).catch(e => {
                console.log(e.response)
                var errorMsg = e.response.data.errorMessage
                this.setState({ loading: false })
                this.props._close()
                this.props._callBack()
                errorMsg.forEach(d => {
                    if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                    else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
                })
            })

    }


    render() {
        return (
            <div>
                <Modal isOpen={this.props.visible} className='journey-edit-holiday'>
                    <ModalHeader close={<button className="close" onClick={() => this.props._close()}>&times;</button>}>{this.props.data.description}</ModalHeader>
                    <ModalBody>
                        {this.state.loading ? (
                            <div style={{ height: '210px' }}>
                                <Loading />

                            </div>
                        ) : (
                            <div className="">
                                <div style={{ width: '220px', marginTop: '10px' }}>
                                    <label htmlFor="start-date-1" style={{ color: '#000' }}>Data</label>
                                    <input
                                        id='start-date-1'
                                        type="date"
                                        className='form-control toolbar-date'
                                        onChange={(i) => this.setState({ dataHolidayEdit: { ...this.state.dataHolidayEdit, date: i.target.value } })}
                                        disabled={this.state.loading}
                                        placeholder='Data'

                                        value={this.state.dataHolidayEdit.date} />
                                </div>

                                <div style={{ width: '220px', marginTop: '10px', }}>
                                    <label htmlFor="description-1" style={{ color: '#000' }}>Descrição</label>
                                    <input
                                        id='description-1'
                                        type="text"
                                        className='form-control toolbar-date'
                                        onChange={(i) => this.setState({ dataHolidayEdit: { ...this.state.dataHolidayEdit, description: i.target.value } })}
                                        disabled={this.state.loading}
                                        placeholder='Descrição'
                                        value={this.state.dataHolidayEdit.description} />
                                </div>

                                <div style={{ width: '220px', marginTop: '10px' }}>
                                    <label htmlFor="drivers-1" style={{ color: '#000' }}>Tipo</label>
                                    {/* Select Motoristas */}
                                    <Select
                                        inputId='drivers-1'
                                        className='toolbar-select'
                                        placeholder="Tipo"
                                        noOptionsMessage={e => { return !e.inputValue ? 'Pesquise o tipo de feriado!' : `"${e.inputValue}" não foi encontrado!` }}
                                        options={this.props.holidayTypes}
                                        // isMulti
                                        isClearable
                                        defaultInputValue={this.state.holidayName}
                                        closeMenuOnSelect={true}
                                        onChange={(i) => {
                                            if (!i) {
                                                this.setState({ dataHolidayEdit: { ...this.state.dataHolidayEdit, scope: '', scopeStr: '' }, holidayName: '' })
                                            }
                                            else {
                                                this.setState({ dataHolidayEdit: { ...this.state.dataHolidayEdit, scope: i.value, scopeStr: i.label }, holidayName: i.label })
                                            }
                                        }}

                                        isDisabled={this.state.loading}
                                    />
                                </div>
                            </div>

                        )}
                        <div style={{ width: '440px', marginTop: '20px', alignSelf: 'center' }}>

                            <ModernAlert msg={this.state.alert.msg} color={this.state.alert.type} />
                        </div>

                    </ModalBody>
                    <ModalFooter>
                        <div style={{ marginTop: '-20px' }}>
                            <input
                                type="button"
                                value='Cancelar'
                                className='telemetry-button btn-new-holiday btn-new-holiday-cancel'
                                onClick={() => this.props._close()}
                                // style={{ marginBottom: '20px' }}
                                disabled={this.state.loading}
                            />
                            <input
                                type="button"
                                value='Salvar'
                                className='telemetry-button btn-new-holiday'
                                onClick={() => this.editHoliday()}
                                // style={{ marginBottom: '20px' }}
                                disabled={
                                    !this.state.dataHolidayEdit.date ||
                                    !this.state.dataHolidayEdit.description ||
                                    !this.state.dataHolidayEdit.scope ||
                                    this.state.loading}
                            />
                        </div>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

export default JourneyEditHoliday